import React from 'react';

import './filter-control.scss';
// import SearchInput from '../search-input/search-input';
import CustomSearchControl from 'components/custom-search-control/CustomSearchControl';
  
interface IProps {
  isOpen: boolean;
}
export const FilterIcon = ({ isOpen }: IProps) => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Icons/Filter</title>
      <g id="Feedback" stroke='none' strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="AmpolCash_Cash_Filters_Collapsed" transform="translate(-1347, -285)">
          <g id="Group-97" transform="translate(45, 269)">
            <g id="iconsFilter" transform="translate(1302, 16)">
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path 
                d="M22,5 C22,4.62977778 22,4.29644444 22,4 L16,4 C16,4.30488889 16,4.64266667 16,5.01333333 C16,5.38355556 16,5.71244444 16,6 L22,6 C22,5.69644444 22,5.36311111 22,5 Z M14,7 L14,2.97333333 C14,2.43266667 13.5625,2 13,2 C12.4375,2 12,2.43333333 12,2.974 L12,4.01266667 L2,4.01266667 C2,4.302 2,4.62666667 2,4.98666667 C2,5.34755556 2,5.67222222 2,5.96066667 L12,5.96066667 L12,7 C12,7.54066667 12.5,8 13,8 C13.5,8 14,7.53 14,7 Z M2,12 C2,12.3702222 2,12.7035556 2,13 L7,13 C7,12.6951111 7,12.3573333 7,11.9866667 C7,11.6164444 7,11.2875556 7,11 L2,11 C2,11.3035556 2,11.6368889 2,12 Z M9,10 L9,14.0266667 C9,14.5673333 9.4375,15 10,15 C10.5625,15 11,14.5666667 11,14.026 L11,13.008728 L22,13.008728 L22,11.0012817 L11,11.0012817 L11,10 C11,9.45933333 10.5,9 10,9 C9.5,9 9,9.47 9,10 Z M22,19 C22,18.6297778 22,18.2964444 22,18 L16,18 C16,18.3048889 16,18.6426667 16,19.0133333 C16,19.3835556 16,19.7124444 16,20 L22,20 C22,19.6964444 22,19.3631111 22,19 Z M14,21 L14,16.9733333 C14,16.4326667 13.5625,16 13,16 C12.4375,16 12,16.4333333 12,16.974 L12,18.0126667 L2,18.0126667 C2,18.302 2,18.6266667 2,18.9866667 C2,19.3475556 2,19.6722222 2,19.9606667 L12,19.9606667 L12,21 C12,21.5406667 12.5,22 13,22 C13.5,22 14,21.53 14,21 Z" 
                id="Shape" 
                fill={isOpen ? '#ed0c06' : '#222'} 
                fillRule="nonzero">
              </path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
interface FilterControlProps {
  showSearch?: boolean;
  // eslint-disable-next-line no-unused-vars
  handleSearch?: (value: string) => void;
  defaultSearchValue?: string;
  // eslint-disable-next-line no-unused-vars
  searchSchema?: (searchTerm: string) => string;
  searchPlaceholder?: string;
  showFilterControl: boolean;
  filterDisplay?: boolean;
  filterApplied?: boolean;
  filterToggle?: () => void;
  children?: React.ReactNode;
}

const FilterControl = ({
  showSearch,
  handleSearch,
  defaultSearchValue,
  searchSchema,
  searchPlaceholder,
  showFilterControl,
  filterDisplay,
  filterApplied,
  filterToggle,
  children,
}: FilterControlProps) => {

  return (
    <>
      <div id='accordion-control' className={`accordion-filter ${(showSearch && !showFilterControl)  && 'accordion-filter__searchContainer'}`}>
        {showFilterControl === true &&
          <button
            type='button'
            aria-label='Toggle filter options'
            className={'accordion-button'}
            data-testid={'filter-button'}
            onClick={filterToggle}>
            Filter
          </button>
        }
        {
          showSearch &&
          <CustomSearchControl 
            onSearch={handleSearch}
            className={'accordion-filter__search'}
            defaultValue={defaultSearchValue}
            searchSchema = {searchSchema}
            placeHolder={searchPlaceholder}
          />
        }
        {showFilterControl && 
          <button
            type='button'
            aria-label='Toggle filter options'
            className={`icon-button ${filterDisplay || filterApplied ? 'icon-button--applied' : ''}`}
            style={{ 'padding': '0 0 0 24px' }}
            data-testid={'filter-button'}
            onClick={filterToggle}>
            <FilterIcon isOpen={filterDisplay || filterApplied} />
          </button>
        }
      </div>
      <div style={{ display: filterDisplay ? 'block' : 'none' }}>{children}</div>
    </>
  );
};

export default FilterControl;
